var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-size-7 has-text-danger has-text-weight-bold"},[_vm._v(" "+_vm._s(_vm.formattedCostString)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }